export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export interface ShowSnackbarAction {
  type: typeof SHOW_SNACKBAR;
  payload: { message: string };
}

export interface HideSnackbarAction {
  type: typeof HIDE_SNACKBAR;
}

export type SnackbarActionTypes = ShowSnackbarAction | HideSnackbarAction;
